import { gql } from "@apollo/client";

export const GET_TIPO_MODULOS = gql`
query GetTipoModulos {
    allTipoModulo
    {
        idTipoModulo,
        descripcion,
        abreviacion,
        idTipoServicio
        rP
        llevaIndicacion
        rI
    }
}
`;

export const adaptTipoModulo = (tipoModulo) => {
  return {
    id: tipoModulo?.idTipoModulo,
    displayName: tipoModulo?.descripcion,
    abreviacion: tipoModulo?.abreviacion,
    rp: tipoModulo?.rP,
    llevaIndicacion: tipoModulo?.llevaIndicacion,
    ri: tipoModulo?.rI
  };
};

export const adaptTipoModulosArray = (
allTipoModulo) =>
{
  return structuredClone(allTipoModulo)?.
  map((tipoModulo) => adaptTipoModulo(tipoModulo));
};